import React, { useRef } from "react";
import { useCarContext } from "../context/CarContext";
import { useParams } from "react-router-dom";
import { motion, LayoutGroup } from "framer-motion";
import CarCard from "./CarCard";
import { useTranslation } from "react-i18next";

const NewArrival: React.FC = () => {
  const { t } = useTranslation();
  const { cars } = useCarContext();
  const { lang } = useParams<{ lang?: string }>();
  const selectedLang = ["en", "fr", "de"].includes(lang || "") ? lang! : "en";
  const ref = useRef(null);

  if (!cars?.length) {
    return <p>{t("cars.noCars")}</p>; 
  }

  const featuredCars = cars.slice(0, 3);

  return (
    <motion.section className="new-arrival-container" ref={ref}>
      <div className="new-arrival-title-container">
        <h2 className="new-arrival-title">{t("newArrival.title")}</h2>
        <p className="new-arrival-subtitle">{t("newArrival.subtitle")}</p>
      </div>

      <LayoutGroup>
        <div className="car-list" key={selectedLang}>
          {featuredCars.map((car, index) => (
            <CarCard
              key={car.id}
              car={car}
              selectedLang={selectedLang}
              index={index}
            />
          ))}
        </div>
      </LayoutGroup>
    </motion.section>
  );
};

export default NewArrival;
